import useReactRouter from 'use-react-router';

export const useCoursePrefix = () => {
	const { location } = useReactRouter();
	let match = location.pathname.match(/\/[^/]*/);
	let prefix = match ? match[0] : '';

	return (prefix == '/ahsj' || prefix == '/svla') ? prefix : '';
}
